/* eslint-disable max-len */
export const findProductById = (state) => (payload) => state.products.findIndex((product) => product.id === payload);
export const findProduct = (state) => (payload) => state.products.find((product) => product.id === payload);
export const getProducts = (state) => state.products;

export function getProductByIndex(state) {
  return (index) => state.products.find((product) => product.uid === index);
}

export function getProductQuantity(state) {
  let total = 0;
  state.products.forEach((p) => { total += (p.quantity || 1); });

  return total;
}
